import React, { useEffect } from 'react';
import { Header } from './components/lp1/Header';
import { HeroSection } from './components/lp1/HeroSection';
import { ProblemSection } from './components/lp1/ProblemSection';
import { UMPSection } from './components/lp1/UMPSection';
import { ProductSection } from './components/lp1/ProductSection';
import { TestimonialsSection } from './components/lp1/TestimonialsSection';
import { MothersTestimonialsSection } from './components/lp1/MothersTestimonialsSection';
import { PricingSection } from './components/lp1/PricingSection';
import { Footer } from './components/lp1/Footer';
import { RecentPurchaseNotification } from './components/lp1/RecentPurchaseNotification';
import { LiveVisitorCounter } from './components/lp1/LiveVisitorCounter';
import { GoogleTagManager } from './components/GoogleTagManager';
export function Lp1App() {
  useEffect(() => {
    // Set the page title
    document.title = 'Baby Food Made Simple';
    // Log to verify the component has mounted
    console.log('LP1 App mounted - GTM should initialize');
    // Push a custom event to dataLayer to verify GTM is working
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageView',
        pagePath: '/lp1',
        pageTitle: 'Baby Food Made Simple'
      });
    }
  }, []);
  return <div className="bg-white min-h-screen font-sans text-gray-900" data-id="element-713">
      <GoogleTagManager gtmId="GTM-WBW5XHKP" data-id="element-714" />
      <Header data-id="element-715" />
      <main data-id="element-716">
        <HeroSection data-id="element-717" />
        <UMPSection data-id="element-718" />
        <ProductSection data-id="element-719" />
        <TestimonialsSection data-id="element-720" />
        <MothersTestimonialsSection data-id="element-721" />
        <PricingSection data-id="element-722" />
      </main>
      <Footer data-id="element-723" />
      <RecentPurchaseNotification data-id="element-724" />
      <LiveVisitorCounter data-id="element-725" />
    </div>;
}